angular
  .module("app.containers")

  .component("accordionContainer", {
    transclude: true,
    templateUrl:
      "ng/containers/accordionContainer/accordionContainer.view.html",
    bindings: {
      //Shown process title is a convetion: propMap[processName + '_' + processIndex]
      topTitle: "@",
      id: "@",
      containerClass: "@",
      bodyStyle: "@",
      isCollapsed: "=",
      notCollapsable: "<",
      titleNotUppercase:"<"
    },
    controllerAs: "AccordionContainerCtrl",
    controller: function AccordionContainerController(
      $timeout
      ){
        var self = this;
        self.maxChar = 166;
    
        self.$onInit = function() {
          self.supportModel = { };
          checkAndEnableTooltip();
        }
    
        var checkAndEnableTooltip = function(){
          $timeout(function(){
            if(self.topTitle && self.topTitle.length > self.maxChar){
              self.enableToltipCliente = true;
            }
          },1000)
        }
      }
  });

  